<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle" id="main-content" >
            {{pageTitle}}</h1>
        <h2 class="govuk-heading-m">{{verifyPageText}}</h2>
        @if(webhookResponseStatus) {
          <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
        }

    </div>
</div>

@if(failed) {
  <div class="govuk-grid-column-two-thirds">
    <h1 class="govuk-heading-l">Sorry, there has been a problem</h1>
    <p class="govuk-body">Try again later.</p>
    <p class="govuk-body">Charge ID: {{ chargeId }}</p>
    <p class="govuk-body">Receipt: {{ receipt }}</p>
    <p class="govuk-body">Internal ref: {{ ref }}</p>
  </div>
}